import { useConfig } from '@travelwin/core';
import { Trans } from 'react-i18next';

import { useClientMarketingConsent } from '@/hooks';
import { useExternalHomepageConfig } from '../../hooks/useExternalHomepageConfig';
import { Anchor } from '../Anchor';

export function TermsDisclaimer({ children }: { children?: React.ReactNode }) {
  const { TERMS_AND_CONDITIONS_URL, PRIVACY_POLICY_URL } = useConfig();
  const { getLocalisedUrl } = useExternalHomepageConfig();
  const { clientMarketingConsent } = useClientMarketingConsent();

  return (
    <p className={'flex flex-column gap-16'}>
      <span>
        <Trans
          i18nKey="login.conditions_disclaimer"
          defaults="By continuing, you agree to the <terms-link>Terms and Conditions</terms-link> and the <privacy-link>Privacy and Cookie Policy</privacy-link>."
          components={{
            'terms-link': (
              <Anchor
                href={getLocalisedUrl(TERMS_AND_CONDITIONS_URL)}
                target="_blank"
                rel="noopener noreferrer"
              />
            ),
            'privacy-link': (
              <Anchor
                href={getLocalisedUrl(PRIVACY_POLICY_URL)}
                target="_blank"
                rel="noopener noreferrer"
              />
            ),
          }}
        />
      </span>

      {children}

      {clientMarketingConsent && clientMarketingConsent.enabled && (
        <span>
          <Trans
            i18nKey="login.legal_disclaimer-heathrow"
            defaults="For more information on how we process your data please refer to the <legal-url-1>Heathrow Privacy Notice</legal-url-1> and <legal-url-2>Heathrow Express Privacy Notice</legal-url-2>."
            components={{
              'legal-url-1': (
                <Anchor
                  href={
                    clientMarketingConsent.legalUrl1
                      ? getLocalisedUrl(clientMarketingConsent.legalUrl1)
                      : ''
                  }
                  target="_blank"
                  rel="noopener noreferrer"
                />
              ),
              'legal-url-2': (
                <Anchor
                  href={
                    clientMarketingConsent.legalUrl2
                      ? getLocalisedUrl(clientMarketingConsent.legalUrl2)
                      : ''
                  }
                  target="_blank"
                  rel="noopener noreferrer"
                />
              ),
            }}
          />
        </span>
      )}
    </p>
  );
}
